<template>
  <div class="cs-login-page">
    <!-- 背景封面：女性客服工作场景；加载失败时保留深色渐变底，不影响登录 -->
    <div class="cs-login-bg" :style="{ backgroundImage: `url(${bg})` }"></div>
    <div class="cs-login-mask"></div>

    <div class="cs-login-card">
      <div class="cs-login-logo">客</div>
      <h2>客服工作台</h2>
      <p class="cs-login-sub">TIANXING CUSTOMER SERVICE</p>

      <form @submit.prevent="onSubmit">
        <div class="cs-field">
          <i class="fa fa-user-o"></i>
          <input type="text" v-model="form.login_name" placeholder="用户名" autocomplete="username" required />
        </div>
        <div class="cs-field">
          <i class="fa fa-lock"></i>
          <input type="password" v-model="form.password" placeholder="密码" autocomplete="current-password" required />
        </div>
        <button type="submit" class="cs-login-btn" :disabled="loading">{{ loading ? '登录中...' : '登 录' }}</button>
      </form>

      <p class="cs-login-foot">Copyright 天星堪舆 &copy; 2020-2025</p>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api/cs'

export default {
  name: 'CsLogin',
  data () {
    return {
      form: { login_name: '', password: '' },
      loading: false,
      bg: '/cs/img/bg1.jpg'
    }
  },
  methods: {
    async onSubmit () {
      if (!this.form.login_name || !this.form.password) return
      this.loading = true
      try {
        await authApi.login(this.form.login_name, this.form.password)
        this.$router.replace(this.$route.query.redirect || '/cs/selection-orders')
      } catch (e) {
        this.$message.error(e.uiMessage || e.message || '登录失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import url('/admin/font-awesome/css/font-awesome.min.css');
@import '../styles/cs-theme.scss';
</style>
